import React, { Component } from 'react';
import { Translate } from '$common';



export default class MultipleImageCapture extends Component {
  static type = 'multiple_image_capture';
  static elementName = Translate.get('multiple_image_capture');
  static icon = 'camera';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/multiple-image-capture.js